
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function Navbar() {
  const [showMobileMenu, setShowMobileMenu] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isHome = location.pathname === '/' || location.pathname === '';

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    if (!isHome) {
      window.REACT_APP_NAVIGATE?.(`/#${sectionId}`);
      return;
    }
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setShowMobileMenu(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${scrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-white/95 backdrop-blur-md shadow-sm'}`}>
      <div className="max-w-7xl mx-auto px-6 py-3.5">
        <div className="flex items-center justify-between">
          <Link to="/" className="flex items-center gap-3 cursor-pointer">
            <img
              src="https://static.readdy.ai/image/a5bacf18ca61cb357c27956f131c4424/4bda670db9801ed405ce2fad550ef8f6.png"
              alt="Sierra Kustom Inc. Logo"
              className="h-11 w-auto object-contain"
            />
            <span className="text-lg font-bold text-gray-900 tracking-tight">Sierra Kustom Inc.</span>
          </Link>

          <div className="hidden md:flex items-center gap-7">
            <Link to="/" className="text-sm font-medium text-gray-700 hover:text-amber-600 transition-colors cursor-pointer whitespace-nowrap">Home</Link>
            <Link to="/services" className="text-sm font-medium text-gray-700 hover:text-amber-600 transition-colors cursor-pointer whitespace-nowrap">Services</Link>
            <button onClick={() => scrollToSection('locations')} className="text-sm font-medium text-gray-700 hover:text-amber-600 transition-colors cursor-pointer whitespace-nowrap">Locations</button>
            <button onClick={() => scrollToSection('about')} className="text-sm font-medium text-gray-700 hover:text-amber-600 transition-colors cursor-pointer whitespace-nowrap">About</button>
            <button onClick={() => scrollToSection('portfolio')} className="text-sm font-medium text-gray-700 hover:text-amber-600 transition-colors cursor-pointer whitespace-nowrap">Portfolio</button>
            <button onClick={() => scrollToSection('contact')} className="text-sm font-medium text-gray-700 hover:text-amber-600 transition-colors cursor-pointer whitespace-nowrap">Contact</button>
            <a href="tel:7805178242" className="bg-gradient-to-r from-amber-600 to-amber-500 text-white px-6 py-2.5 rounded-full hover:from-amber-700 hover:to-amber-600 transition-all cursor-pointer whitespace-nowrap font-semibold text-sm shadow-lg shadow-amber-600/30">
              780-517-8242
            </a>
          </div>

          <button
            onClick={() => setShowMobileMenu(!showMobileMenu)}
            className="md:hidden text-gray-700 cursor-pointer"
          >
            <i className={`${showMobileMenu ? 'ri-close-line' : 'ri-menu-line'} text-2xl`}></i>
          </button>
        </div>

        {showMobileMenu && (
          <div className="md:hidden mt-4 pb-4 flex flex-col gap-3">
            <Link to="/" onClick={() => setShowMobileMenu(false)} className="text-sm font-medium text-gray-700 hover:text-amber-600 transition-colors cursor-pointer text-left whitespace-nowrap">Home</Link>
            <Link to="/services" onClick={() => setShowMobileMenu(false)} className="text-sm font-medium text-gray-700 hover:text-amber-600 transition-colors cursor-pointer text-left whitespace-nowrap">Services</Link>
            <button onClick={() => scrollToSection('locations')} className="text-sm font-medium text-gray-700 hover:text-amber-600 transition-colors cursor-pointer text-left whitespace-nowrap">Locations</button>
            <button onClick={() => scrollToSection('about')} className="text-sm font-medium text-gray-700 hover:text-amber-600 transition-colors cursor-pointer text-left whitespace-nowrap">About</button>
            <button onClick={() => scrollToSection('portfolio')} className="text-sm font-medium text-gray-700 hover:text-amber-600 transition-colors cursor-pointer text-left whitespace-nowrap">Portfolio</button>
            <button onClick={() => scrollToSection('contact')} className="text-sm font-medium text-gray-700 hover:text-amber-600 transition-colors cursor-pointer text-left whitespace-nowrap">Contact</button>
            <a href="tel:7805178242" className="bg-gradient-to-r from-amber-600 to-amber-500 text-white px-6 py-2.5 rounded-full hover:from-amber-700 hover:to-amber-600 transition-all cursor-pointer text-center whitespace-nowrap font-semibold text-sm">
              780-517-8242
            </a>
          </div>
        )}
      </div>
    </nav>
  );
}
